import { selector } from "recoil";
import { userSearchOptionsAtom } from "../atoms/userSearchOptionsAtoms";

export const userSearchOptionsSelector = selector({
  key: "userSearchOptionsSelector", // セレクターのユニークなキー
  get: ({ get }) => {
    const data = get(userSearchOptionsAtom);
    return data.userSearchOptions;
  },
});
